import { Component, Prop, Provide, Vue } from 'vue-property-decorator'

@Component
export default class LessInfo extends Vue {
    public clickTellUS(e) {
        this.$store.commit('SET_FEEDBACK_STATUS', {}) // 打开反馈弹窗
        e.preventDefault();
    }
}